import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getCurrencyCode, getLocalTaxesIncluded, getTaxesIncluded } from 'modules/meta/selectors';
import { TaxationAndNightlyPriceMessage as TaxationAndNightlyPriceComponent } from '@daedalus/shared/src/search/TaxationAndNightlyPriceMessage';
interface Props {
  /** The max width the message should display at  */
  maxWidth?: number;
  /** Whether to show the currency code or not */
  showCurrencyCode?: boolean;
  /** The hotel id to find the offer entity which contains the number of rooms */
  hotelId: string;
}
const _exp2 = /*#__PURE__*/() => ({
  maxWidth
}) => maxWidth ? `${maxWidth}px` : 'unset';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1eezp26",
  propsAsIs: false,
  vars: {
    "w1eezp26-0": [_exp2()]
  }
});
export const TaxationAndNightlyPriceMessage = ({
  maxWidth,
  showCurrencyCode = false,
  hotelId
}: Props) => {
  const taxesAreIncluded = useSelector(getTaxesIncluded);
  const localTaxesAreIncluded = useSelector(getLocalTaxesIncluded);
  const includeTaxes = taxesAreIncluded || localTaxesAreIncluded;
  const currencyCode = useSelector(getCurrencyCode);
  return <Wrapper maxWidth={maxWidth} id={`HotelCardMobileTaxationAndNightlyPrice-${hotelId}`}>
      <TaxationAndNightlyPriceComponent includeTaxes={includeTaxes} currencyCode={showCurrencyCode ? currencyCode : undefined} />
    </Wrapper>;
};

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");